import React from 'react';
import { QuestionComponentProps } from '../QuestionComponent.types';
import { CustomQuestion } from '../Question';
import ArchievePotentialImgMale from 'assets/livenicons/archievepotential.jpeg';
import ArchievePotentialImgFemale from 'assets/livenicons/archievepotential_female.jpeg';
import { StickyContainer } from 'components/stickycontainer/StickyContainer';
import Spacer from 'components/spacer/Spacer';
import { useAppDispatch, useAppSelector } from 'bootstrap/hooks';
import { appAnalytics } from 'analytics';
import { goToNextQuestion } from 'bootstrap/onboarding/actions';
import { SaveAnswer } from 'analytics/AllEvents';
import { useFeatures } from 'useFeatures';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import styles from './styles.module.scss';
import { Genders } from 'welcome/livenwelcome/LivenWelcome.hook';

type Props = QuestionComponentProps<CustomQuestion>;

export const AchievePotential: React.FC<Props> = ({ question }: Props) => {
  const dispatch = useAppDispatch();
  const features = useFeatures();

  const { answers } = useAppSelector((state) => state.onboarding);

  const isMaleGender = answers[QuestionIds.Welcome] === Genders.Male;

  const nextButtonHandler = () => {
    setTimeout(() => {
      appAnalytics.trackEvent(new SaveAnswer(question.id));
      dispatch(goToNextQuestion(features));
    }, 250);
  };

  return (
    <div className={`${styles.container}`}>
      <img
        src={
          isMaleGender ? ArchievePotentialImgMale : ArchievePotentialImgFemale
        }
        alt=""
      />
      <h3 className={styles.title}>Achieve your full potential!</h3>
      <p className={styles.description}>
        By evaluating your answers in this quiz we'll be able to craft an action
        plan to help you stay focused and achieve your goals
      </p>
      <Spacer />
      <StickyContainer className={styles.buttonContainer}>
        <button className={styles.button} onClick={nextButtonHandler}>
          Continue
        </button>
      </StickyContainer>
    </div>
  );
};
